// Replaying a payment: sending money that arrived, but could not be applied to the policy, for allocation again.

/**
 * Only a payment whose money arrived (status Succeeded) and whose allocation failed (processing status Failed) can be
 * replayed. A payment the partner never collected has nothing to allocate, and one already allocated must never be
 * allocated twice. The server enforces the same rule.
 */
export function canReplayPayment(payment) {
  return (
    !!payment &&
    payment.processing_status === 'Failed' &&
    payment.status === 'Succeeded'
  )
}

/** The reason to show the person, in plain words. */
export function replayReason(payment) {
  if (!payment) return ''
  const reason = payment.payment_failure_reason
  // The reason is dropped into a sentence, so it must not bring its own full stop.
  return reason
    ? String(reason)
        .trim()
        .replace(/\.+$/, '')
    : 'no reason was recorded'
}

/** How many times someone has already replayed this payment, from the payment's own record (the payment service keeps the latest replay). */
export function replayCount(payment) {
  const details = payment && payment.additional_details
  if (!details) return 0
  if (Array.isArray(details.replays)) return details.replays.length
  return details.replay ? 1 : 0
}
